import React from 'react';
import { AutoFocusedForm, DateField, Modal, TextField } from 'components';
import { required } from 'components';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  createStyles,
  Divider,
  Grid,
  makeStyles,
  Theme,
} from '@material-ui/core';
import { useCreateReportForm } from './';
import { Field } from 'react-final-form';
import { MutableButton } from 'ui/MutableButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '500px',
    },
    header: {
      fontWeight: 'bolder',
    },
    actions: {
      justifyContent: 'flex-end',
    },
  })
);

export const CreateReportPopup = () => {
  const classes = useStyles();

  const { onCancel, initialValues, onSubmit, loading } = useCreateReportForm();

  return (
    <Modal
      onClose={onCancel}
      aria-labelledby="Заполнение счета"
      aria-describedby="Используйте эту форму для заполнения счета"
    >
      <AutoFocusedForm
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, pristine }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Card className={classes.root}>
                <CardHeader title="Добавление расхода" />
                <Divider />
                <CardContent>
                  <Grid container spacing={4}>
                    <Grid item lg={12} md={12} xl={12} xs={12}>
                      <Field
                        name="title"
                        component={TextField}
                        label="Краткое описание отчета"
                        validate={required}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={4}>
                    <Grid item lg={12} md={12} xl={12} xs={12}>
                      <Field
                        name="referenceDate"
                        label="Дата отчётного периода"
                        fullWidth={true}
                        component={DateField}
                        returnTime={false}
                        validate={required}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions className={classes.actions}>
                  <MutableButton
                    loading={loading}
                    color="primary"
                    disabled={pristine}
                    size="medium"
                    type="submit"
                    variant="contained"
                  >
                    Сохранить
                  </MutableButton>
                  <Button
                    onClick={onCancel}
                    size="medium"
                    disabled={loading}
                    type="button"
                    variant="contained"
                  >
                    Отменить
                  </Button>
                </CardActions>
              </Card>
            </form>
          );
        }}
      />
    </Modal>
  );
};
